import { render, staticRenderFns } from "./Commit.vue?vue&type=template&id=6059be68&scoped=true"
import script from "./Commit.vue?vue&type=script&lang=js"
export * from "./Commit.vue?vue&type=script&lang=js"
import style0 from "./Commit.vue?vue&type=style&index=0&id=6059be68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6059be68",
  null
  
)

export default component.exports